// Remembers the last non-settings location so the Settings shell's "Exit to app"
// control returns the user where they came from. Best-effort (sessionStorage may be
// unavailable); falls back to the app's default landing route.
const KEY = "instantview.lastAppPath";
export const DEFAULT_APP_PATH = "/financial-control";

export function recordAppPath(pathWithSearch) {
  try {
    window.sessionStorage.setItem(KEY, pathWithSearch);
  } catch {
    /* sessionStorage unavailable — best-effort */
  }
}

export function getLastAppPath() {
  try {
    return window.sessionStorage.getItem(KEY) || DEFAULT_APP_PATH;
  } catch {
    return DEFAULT_APP_PATH;
  }
}
